export const noPaddingAllTypes = [
  false,
  "no",
  "no-top",
  "no-top-right",
  "no-top-bottom",
  "no-top-left",
  "no-top-right-bottom",
  "no-top-right-left",
  "no-top-bottom-left",

  "no-right",
  "no-right-bottom-left",
  "no-right-bottom",
  "no-right-left",

  "no-bottom",
  "no-bottom-left",

  "no-left",

  "no-left-right",
  "no-top-left-right",
  "no-bottom-left-right",
  "no-bottom-right",

  "s",
  "m",
  "l",
  "xl"
];

export const widthViewTypes = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

export const ofsetTypes = [
  "ofset-1",
  "ofset-2",
  "ofset-3",
  "ofset-4",
  "ofset-5",
  "ofset-6",
  "ofset-7",
  "ofset-8",
  "ofset-9",
  "ofset-10",
  "ofset-11",
  "ofset-12"
];

export const showHideTypes = ["hide", "show"];
export const showHideOnlyTypes = ["hide-only", "show-only"];
